import {IconButton, type IconButtonProps} from '@primer/react'
import {clsx} from 'clsx'

import styles from './IconButtonSelector.module.css'

type IconButtonSelectorProps = IconButtonProps & {
  selected: boolean
  selectedIcon?: IconButtonProps['icon']
  'aria-labeledby'?: string
  ref?: React.Ref<HTMLButtonElement>
}

export const IconButtonSelector = ({ref, ...props}: IconButtonSelectorProps) => {
  const {selected, icon: Icon, selectedIcon: SelectedIcon, ...rest} = props
  const IconComponent = selected && SelectedIcon ? SelectedIcon : Icon

  return (
    <IconButton
      {...rest}
      className={clsx(styles.anchor, rest.className)}
      icon={IconComponent}
      data-selected={selected}
      ref={ref}
    />
  )
}

IconButtonSelector.displayName = 'IconButtonSelector'
